var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-agreement flex col",staticStyle:{"width":"1100px","margin":"0 auto","overflow-x":"auto"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }